module.exports = __webpack_public_path__ + "img/24-02_bar-menu3.53a9af56.jpg";